import { batch } from 'react-redux';
import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { EmeraldError } from '../../common/api/emerald-error';
import { store } from '../../common/redux/configure-store';
import { MiddleAreaActions } from '../../common/redux/reducers/middle-area-reducer';
import { RecallOrderActions } from '../../common/redux/reducers/recall-order-reducer';
import { TransactionActions } from '../../common/redux/reducers/transaction-reducer';
import { applyCartResponse } from '../../home-page/business-logic/common/apply-cart-response';
import { getInterventions } from '../../interventions/business-logic/get-interventions';
import { customerOrderGet } from './service/customer-order-get';

export const getRecallOrder = async (orderId: string): Promise<void> => {
  const transactionId = store.getState().transaction.transactionId;
  if (transactionId) {
    throw new EmeraldError('RecallTransactionException_InTransaction');
  }
  await customerOrderGet(orderId).then((transaction: CartResponse): void => {
    batch(() => {
      store.dispatch(
        TransactionActions.setTransactionState({
          transactionId: transaction.cartId ?? '',
          sequenceNumber: transaction.sequenceNumber ?? 0,
        }),
      );
      applyCartResponse(transaction);

      // ShowCustomerMessages(data)
      // ShowLockedForSaleItems(data)
      store.dispatch(RecallOrderActions.resetState());
      store.dispatch(MiddleAreaActions.showActionWindow());
    });
  });
  await getInterventions();
};
